import React, {useEffect} from "react";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {setOnboardingStatus} from "../../Redux/CommonReducer";
import {styled} from "@mui/styles";

const StyledOnboardingWhatsNew = styled('a')(() => ({
    display: 'inline-block',
    marginLeft: '20px',
    fontSize: '0.5em',
    color: 'var(--siteconfig-ui-btn-stdcolor-rgba)',
    verticalAlign: 'top',
    lineHeight: '2.2rem',
    paddingTop: '3px',

    '& i': {
        marginRight: '10px',
    },
}));

const WhatsNew = (props) => {
    const dispatch = useDispatch();

    const onboardingStatus = useSelector(state => state.module['VISITORS'].common.onboarding[props.tag]);

    const [ isVisible, setIsVisible ] = React.useState(false);

    useEffect(() => {
        setIsVisible(['active', 'ignored'].includes(onboardingStatus));
    }, [onboardingStatus])

    const handleOnClick = (e) => {
        e.preventDefault();
        dispatch(setOnboardingStatus(props.tag, 'active'));
    }

    if (!isVisible) {
        return null;
    }

    return (
        <StyledOnboardingWhatsNew onClick={e => handleOnClick(e)}>
            <i className="fa fa-comment"></i>
            What's New?
        </StyledOnboardingWhatsNew>
    )
}

WhatsNew.propTypes = {
    tag: PropTypes.string.isRequired,
}

WhatsNew.defaultProps = {
    tag: null,
}

export default WhatsNew;
